import { Link } from '@fs/zion-router'
import { QuickGlanceOverlay, ResponsiveTableRow, useOverlay, Button, Separator } from '@fs/zion-ui'
import { React } from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { getIdElement } from '../../../util/StringUtil'
import { CisLink } from '../../app/Links'
import DmcCopyToClipboardTooltip from '../../../util/DmcCopyToClipboardTooltip'

/**
 * Used in the <EventsPanel> to display info about the patron who trigged an event
 */
export default function PatronDialogOverlay({ patron }) {
  const [t] = useTranslation()
  const columnHeaders = ['', ' ']
  const patronInfoOverlay = useOverlay()

  return (
    <div>
      <Button onClick={patronInfoOverlay.handleClick}>{patron.id}</Button>
      <QuickGlanceOverlay {...patronInfoOverlay} title={t('artifacts.patronInfo', 'Patron Info')}>
        <DmcResponsiveTable
          totalColumnCount={columnHeaders.length}
          atSizeColumns={{
            default: {
              labels: columnHeaders,
            },
          }}
          separator={<br />}
          stickyHeader={false}
        >
          <ResponsiveTableRow column1={t('name', 'Name')} column2={patron.name} />
          <ResponsiveTableRow column1={t('userName', 'Username')} column2={patron.userName} />
          <ResponsiveTableRow
            column1={t('email', 'Email')}
            column2={patron.email && <a href={`mailto:${patron.email}`}>{patron.email}</a>}
          />
          <ResponsiveTableRow
            column1={t('artifacts.patronId', 'Patron ID')}
            column2={
              <div>
                {patron.id}
                <br />
                <Link to={`/artifacts/patron/mp.${patron.id}`} target="_blank" noScrollTop>
                  {t('artifacts.viewPatronArtifacts', 'View patron’s artifacts')}
                </Link>
              </div>
            }
          />
          <ResponsiveTableRow
            column1={t('account.status', 'Account Status')}
            column2={t(`artifacts.patronStatus.${patron.status}`, patron.status)}
          />
          <ResponsiveTableRow
            column1={t('cisUserId', 'CIS User ID')}
            column2={
              patron?.cisUserId?.startsWith('cis.user') ? (
                <div>
                  <DmcCopyToClipboardTooltip value={getIdElement(patron.cisUserId)} />
                  <br />
                  <CisLink
                    userId={getIdElement(patron.cisUserId)}
                    text={t('artifacts.viewUserSummary', 'View user summary')}
                  />
                </div>
              ) : (
                <div>
                  <DmcCopyToClipboardTooltip value={patron.cisUserId} />
                  <Separator />
                </div>
              )
            }
          />
        </DmcResponsiveTable>
      </QuickGlanceOverlay>
    </div>
  )
}
